import { AnimatePresence, motion } from "framer-motion";

import Body from "~/components/Body";
import ExpressBanner from "~/components/ExpressBanner";
import Footer from "~/components/Footer";
import LoadingAnimation from "~/components/LoadingAnimation";
import Navbar from "~/components/Navbar";
import type { Layout } from "~/types";

const PrimaryLayout: Layout<{
	isLoading?: boolean;
	hideFooter?: boolean;
	hideExpressBanner?: boolean;
}> = ({
	isLoading,
	children,
	breadcrumbs,
	hasAppBar,
	hideFooter,
	hideExpressBanner,
}) => {
	return (
		<AnimatePresence mode="wait">
			{isLoading ? (
				<motion.div
					initial={{ opacity: 0 }}
					animate={{ opacity: 1 }}
					exit={{
						opacity: 0,
						transition: {
							delay: 0.2,
						},
					}}
					className="h-screen w-screen"
					key="loading"
				>
					<LoadingAnimation />
				</motion.div>
			) : (
				<div key="content">
					<div className="flex min-h-screen flex-col">
						<Navbar breadcrumbs={breadcrumbs} />
						<Body>{children}</Body>

						{!hideExpressBanner && <ExpressBanner hasAppBar={hasAppBar} />}
					</div>

					{!hideFooter && <Footer />}
				</div>
			)}
		</AnimatePresence>
	);
};

export default PrimaryLayout;
